import script from "./PolDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PolDialog.vue?vue&type=script&setup=true&lang=js"

import "./PolDialog.vue?vue&type=style&index=0&id=7ece6eee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ece6eee"]])

export default __exports__